import React from 'react';
import type { ButtonHTMLAttributes } from 'react';
import './ui.css'; // We will create this for component styles

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'primary', size = 'md', isLoading, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`btn btn-${variant} btn-${size} ${isLoading ? 'btn-loading' : ''} ${className}`}
        disabled={isLoading || props.disabled}
        {...props}
      >
        {isLoading && <span className="spinner mr-2" />}
        {children}
      </button>
    );
  }
);
Button.displayName = 'Button';
